import React from 'react'

const DocSearchDynamicGroupChoiceRow = (props) => {
    const { viewData, selectedKey } = props;

    const renderDataValue = (row, rowValueKey) =>{
        var rowValue = row.rowValues[rowValueKey];

        return (
            <div className="uiFlexBox3">
                <span style={{fontWeight:'bold', width: '190px', display:'inline-block'}}>{rowValue.dataList.label}</span>
                <span>{rowValue.valF || rowValue.val}</span>
            </div>
        )
    }

    const renderData = () =>{
        // console.log("renderData", viewData);

        if(viewData && (viewData.RowValuesKeys.length > 0)){
            return(
                <div className="uiBox" style={{margin:'0px'}}>
                {
                    viewData.RowValuesKeys.map((rowValueKey, index)=>(
                        <div key={index}>
                            {renderDataValue(viewData, rowValueKey)}
                        </div>
                    ))
                }
                </div>
            )
        }
        else{
            return null;
        }
    }

    return (
        <div
            className={selectedKey === 1 ? "uiSelectedListRow" : "uiListRow"}
        >
            <span className='uiListTitle'>{viewData.dataList.label}</span>
            <span className="uiListRowStats">{renderData()}</span>
        </div>
    )
}

export default DocSearchDynamicGroupChoiceRow;
